import '../../../App.css';
import SimpleMode from './simpleMode.js';
import React, { useState } from 'react';
import Footer from '../../footer.js';
import Header from '../../header/header.js';
import Navvbar from '../../header/Navvbar.js';


const CompleteTasks = () => {

    const [selectedAccount, setSelectedAccount] = useState("");
    const handleAccountChange = (event) => {
    
        setSelectedAccount(event.target.value); 
      };
      const [accounts, ] = useState([]);
      
      const [selectedProcedure, setSelectedProcedure] = useState("");
      const handleProcedureChange = (event) => {
       
          setSelectedProcedure(event.target.value); 
        };
        const [procedure, ] = useState([]);

        const [selectedUser, setSelectedUser] = useState("");
        const handleUserChange = (event) => {
     
            setSelectedUser(event.target.value); 
          };
          const [user, ] = useState([]);


  const [loading, ] = useState(true);
  const [error, ] = useState(null);
  const [isToggled, setIsToggled] = useState(false);


    // Function to toggle the mode
    const handleToggle = () => {
        setIsToggled(!isToggled);
      };

    return (
        <>
            <Header />
            <Navvbar/>
            <div style={{ marginTop: '20px', width: '95%',  margin: '0 auto' ,padding:"20px" }}>
    <h2>Complete Waiting Tasks</h2>
    <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center' }}>
        <h6>Advanced with search</h6>
        
        <div onClick={handleToggle} 
            style={{
                width: "50px",
                height: "25px",
                backgroundColor: isToggled ? "#004aad" : "#ccc",
                borderRadius: "25px",
                position: "relative",
                cursor: "pointer",
                transition: "background-color 0.3s",
            }}
        >
            <div
                style={{
                    width: "22px",
                    height: "22px",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    position: "absolute",
                    top: "50%",
                    left: isToggled ? "26px" : "2px",
                    transform: "translateY(-50%)",
                    transition: "left 0.3s",
                    boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
                }}
            />
        </div>

        <h6 style={{ marginLeft: '10px' }}>Simple Mode</h6>
    </div>

    {/* Ye sirf tab dikhayega jab toggle on ho */}
    {isToggled && (
        <div>
            <SimpleMode />
        </div>
    )}
</div>
{!isToggled && (
    <div style={{ backgroundColor: '#EFEFEF', padding: '20px', borderRadius: '8px', marginTop: '20px',width: '95%',  margin: '0 auto'  }}>
        <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}}>
        <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
    <h4 style={{ color: "#1E90FF", marginLeft: "0px" }}>Task Search Options</h4>
    <h4 style={{ color: "#1E90FF", position: "absolute", right: "240px" }}>Scan Settings</h4>
</div>
        </div>

        {/* Account, Procedure, Task dropdowns */}
        <div className="container" style={{ marginTop: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="col-3" style={{ display: 'flex', alignItems: 'center' }}>
                    <label htmlFor="account" className="form-label" style={{ marginRight: '55px' }}>Account</label>
                    <select id="account" className="form-select form-select-sm" style={{ width: '180px' }} value={selectedAccount} onChange={handleAccountChange}>
                        <option value="" disabled>Select Account</option>
                        {loading && <option>Loading...</option>}
                        {error && <option>{error}</option>}
                        {!loading && !error && accounts.map((account) => (
                            <option key={account.id} value={account.id}>{account.account_name}</option>
                        ))}
                    </select>
                </div>

                <div className="col-3" style={{ display: 'flex', alignItems: 'center', marginRight: '120px' }}>
                    <label htmlFor="user" className="form-label" style={{ marginRight: '10px' }}>User</label>
                    <select id="user" className="form-select form-select-sm" style={{ width: '200px' }} value={selectedUser} onChange={handleUserChange}>
                        <option value="" disabled>Select User</option>
                        {loading && <option>Loading...</option>}
                        {error && <option>{error}</option>}
                        {!loading && !error && user.map((user) => (
                            <option key={user.id} value={user.id}>{user.user_name}</option>
                        ))}
                    </select>
                </div>
            </div>
        </div>

        <br />

        <div className="col-3" style={{ display: 'flex', alignItems: 'center' }}>
            <label htmlFor="procedure" className="form-label" style={{ marginRight: '2px' }}>Procedure</label>
            <select id="procedure" name="procedure" className="form-select form-select-sm" style={{ marginLeft: "50px" }} value={selectedProcedure} onChange={handleProcedureChange}>
                <option value="" disabled>Select Procedure</option>
                {loading && <option>Loading...</option>}
                {error && <option>{error}</option>}
                {!loading && !error && procedure.map((procedure) => (
                    <option key={procedure.id} value={procedure.id}>{procedure.procedure_name}</option>
                ))}
            </select>
        </div>

        <br />

        <div style={{ display: 'flex', alignItems: 'center' }}>
            <input type="checkbox" id="autoCompleteNextTask" name="autoCompleteNextTask" style={{ marginRight: '10px' }} />
            <label htmlFor="autoCompleteNextTask" style={{ fontSize: '14px', color: '#333' }}>
                Auto Complete Next Task on Case Search
            </label>
        </div>

        <div>
            <label style={{ fontStyle: 'italic', color: 'gray', display: 'flex', alignItems: 'center' }}>
                The effect on the scanned case is based on tasks that match the search parameters.<br />
                If there is a "Waiting" task for the scanned case, the first "Waiting" task is "Completed".
            </label>
        </div>

        <div className="container" style={{ marginTop: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <label htmlFor="caseNumber" className="form-label" style={{ marginRight: '40px' }}>Case #</label>
                <input type="text" id="caseNumber" name="caseNumber" className="form-control" style={{ width: '200px' }} />
            </div>
        </div>
    </div>
)}
                <br/>
                <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}}>
                <b>Task : Waiting</b>
                <br/>
                <p>No tasks to display</p>
            </div>
            <div style={{width:"100%",marginTop:"13%"}}>
                <Footer />
            </div>
        </>
    );
};

export default CompleteTasks;
